<app-header
  [user]="user"
  [homeLink]="homeLink"
  [dropdownMenuItems]="headerDropdownMenuItems"
  [variant]="organizerVariant"
  [logo]="organizerLogo"
  class="organizer-shared-layout-dashboard-header"
>
  <app-organizer-shared-layout-dashboard-header-navigation
    *ngIf="!isTabletDevice"
    navigation
    [unreadMessagesNumber]="unreadMessages"
    class="col-span-5"
  ></app-organizer-shared-layout-dashboard-header-navigation>
  <a
    *ngIf="!isTabletDevice"
    right-content
    app-vtmn-play-button
    class="my-2 mr-4"
    [variant]="vtmnPlayButtonVariant.PRIMARY"
    (click)="checkOrganizationStatus($event)"
  >
    {{ 'shared_organizer.layouts.dashboard.header.schedule' | translate }}
  </a>

  <app-navigation-tab-bar
    *ngIf="isTabletDevice"
    tab-navigation
    [distribution]="distribution"
    [buttonsConfig]="tabBarButtons"
    class="fixed z-1 bottom-0 left-0 w-full lg:hidden"
  ></app-navigation-tab-bar>
</app-header>
<app-alert-modal
  #accountModal
  class="organizer-modal-account"
  (modalClose)="accountModal.hide()"
  (modalConfirm)="confirmModalHandler()"
  [confirmLabel]="
    'organizer.header.status.modal.confirmbutton.' + organizerStatus | translate
  "
  [closeLabel]="
    'organizer.header.status.modal.dashboardbutton.' + organizerStatus
      | translate
  "
  [hasCloseButton]="modalAccountSecondaryButton"
  [buttonVariant]="true"
>
  <div modal-header>
    <div class="organizer-modal-account__logo">
      <app-logo
        [alt]="'a11y.header.logo.link' | translate"
        [height]="48"
        [name]="organizerLogo"
      ></app-logo>
    </div>
    <div class="organizer-modal-account__title">
      {{ 'organizer.header.status.modal.title.' + organizerStatus | translate }}
    </div>
  </div>
  <p modal-content class="organizer-modal-account__content">
    {{ 'organizer.header.status.modal.content.' + organizerStatus | translate }}
  </p>
</app-alert-modal>
<app-alert-modal
  *appIsEnabled="toggleNameEnum.OrganizerDashboardMaintenance"
  #maintenanceModal
  class="organizer-modal-account"
  (modalConfirm)="maintenanceModalHandler()"
  [hasCloseButton]="false"
  [confirmLabel]="'organizer.header.maintenance.modal.button' | translate"
  [buttonVariant]="true"
>
  <div modal-header>
    <div class="organizer-modal-account__logo">
      <app-logo
        [alt]="'a11y.header.logo.link' | translate"
        [height]="48"
        [name]="organizerLogo"
      ></app-logo>
    </div>
    <div class="organizer-modal-account__title">
      {{ 'organizer.header.maintenance.modal.title' | translate }}
    </div>
  </div>
  <p
    modal-content
    class="organizer-modal-account__content organizer-modal-account__content--variant"
  >
    {{ 'organizer.header.maintenance.modal.description' | translate }}
  </p>
</app-alert-modal>

<app-alert-modal
  #organizerFedModal
  class="organizer-modal-account"
  (modalConfirm)="organizerFedModalHandler()"
  [hasCloseButton]="false"
  [confirmLabel]="'organizer.header.organizer.modal.button' | translate"
  [buttonVariant]="true"
>
  <div modal-header>
    <div class="organizer-modal-account__logo">
      <app-logo
        [alt]="'a11y.header.logo.link' | translate"
        [height]="48"
        [name]="organizerLogo"
      ></app-logo>
    </div>
    <div class="organizer-modal-account__title">
      {{ 'organizer.header.organizer.modal.title' | translate }}
    </div>
  </div>
  <p
    modal-content
    class="organizer-modal-account__content organizer-modal-account__content--variant"
  >
    {{ 'organizer.header.organizer.modal.description' | translate }}
  </p>
</app-alert-modal>
